import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {BadgeColorsEnum} from '../../../../shared/interfaces/BadgeColorsEnum';
import {ActivityTypesEnum} from '../../../../shared/interfaces/ActivityTypesEnum';
import {getDateFromISO} from '../../../../shared/helpers/helpers';
import {IInventory} from '../../../../shared/interfaces/inventory.interface';
import {Select, Store} from '@ngxs/store';
import {
  ArchiveNDC,
  SetActiveInventoryList,
  SetCurrentInventory,
} from '../../../../shared/states/inventory/inventory.actions';
import {BaseTableDirective} from '../../../../shared/directives/base-table.directive';
import {take, withLatestFrom} from 'rxjs/operators';
import {TransactionsState} from '../../../../shared/states/transactions/transactions.state';
import {Observable} from 'rxjs/internal/Observable';
import { PharmacyState } from 'src/app/shared/states/pharmacy/pharmacy.state';

@Component({
  selector: 'app-inventory-table',
  templateUrl: './inventory-table.component.html',
  styleUrls: ['./inventory-table.component.scss'],
})
export class InventoryTableComponent extends BaseTableDirective implements OnInit {
  private _inventoryList: IInventory[];
  get inventoryList(): IInventory[] {
    return this._inventoryList;
  }

  @Input()
  set inventoryList(val: IInventory[]) {
    this._inventoryList = this.apply_existing_sort(val, this.currentSortCol);
  }

  @Output() ndcArchived: EventEmitter<any> = new EventEmitter();

  tableColumns = {
    friendlyName: true,
    onHand: true,
    ['lastActivityTransactionDate']: false,
    lastAuditDetailConfirmationDate: true,
    allLocationsOnHand: false,
    similarOnHand: false
  };
  currentSortCol = 'lastActivityTransactionDate';
  currentInventory: IInventory;
  showArchiveNDCDialog: boolean;

  BadgeColorsEnum = BadgeColorsEnum;
  ActivityTypesEnum = ActivityTypesEnum;

  getDateFromISO = getDateFromISO;

  @Select(TransactionsState.archivingStatus) archivingStatus$: Observable<boolean>;
  @Select(PharmacyState.inventoryLocationsEnabled) inventoryLocationsEnabled$: Observable<boolean>;
  inventoryLocationsEnabled: boolean;
  constructor(
    private router: Router,
    protected store: Store,
  ) {
    super(store);
  }

  ngOnInit(): void {
   this.inventoryLocationsEnabled$
   .pipe(take(1))
   .subscribe(val => {
    this.inventoryLocationsEnabled = val;
   })
  }

  openSingleRecordTable(inventory: IInventory): void {
    this.store.dispatch(new SetCurrentInventory(inventory));
    this.router.navigate(['inventory', inventory.drugID]);
  }

  goToAudit(id: number) {
    if(id) {
      event.stopImmediatePropagation();
      this.router.navigate(['audits/details', id], {state : {navigatedFrom: this.router.url}});
    }
  }


  openArchiveDialog(inventory: IInventory): void {
    this.currentInventory = inventory;
    this.showArchiveNDCDialog = true;
  }

  sortByColumn(columnName: string): void {
    this.currentSortCol = columnName;
    this.store.dispatch(new SetActiveInventoryList(this.sort(this._inventoryList, columnName)));
  }

  closeArchiveNDCDialog(): void {
    this.showArchiveNDCDialog = false;
  }

  archiveNDC(): void {
    this.store.dispatch(new ArchiveNDC(this.currentInventory))
      .pipe(take(1), withLatestFrom(this.archivingStatus$))
      .subscribe(([_, status]) => {
        this.closeArchiveNDCDialog();
        this.ndcArchived.emit({success: status, inventory: this.currentInventory});
      });
  }

  openSohReport(row: IInventory): void {
    if (row.gpi) {
      this.router.navigate(['reports/similar-on-hand-history'], {state: {
        selectedNdc: { //represents multiselect dropdown item in soh report
           id: row.drugID,
           text: row.friendlyName,
           additionalText: row.packageNdc,
        },
        gpi: row.gpi,
        navigatedFrom: this.router.url
      }});
    }
  }
}
